import { Button, Group, Text } from "@mantine/core"
import { useOfferById } from "@features/offers"
import Card from "components/Card"
import Content from "components/Content"
import { FormatCurrency } from "components/Currency"
import type React from "react"
import { useNavigate, useParams } from "react-router-dom"

const OfferEmptyState: React.FC = () => {
  const navigate = useNavigate()
  const { offerId } = useParams<Record<string, string | undefined>>()
  const offer = useOfferById(offerId)

  const onGeneratePdf = (): void => {
    navigate(`/offers/${offerId}/pdf`)
  }

  const onPostsClick = (): void => {
    navigate(`/offers/${offerId}/post`)
  }

  if (!offer) {
    return (
      <Content title="Detalhes da Oferta">
        <Card title="Erro">
          <div className="p-3">A oferta não foi encontrada!</div>
        </Card>
      </Content>
    )
  }

  const {
    AccommodationName,
    OfferTitle,
    LeadInPrice,
    ImageURL,
    WhatsIncluded,
    Nights,
    StarRating,
  } = offer

  return (
    <div className="w-full">
      <Card title={OfferTitle}>
        <div className="p-3">
          <div className="relative">
            <div className="relative p-3 flex flex-col-reverse rounded-lg bg-gradient-to-t from-black/75 via-black/0">
              <Text fw={600} size="lg" c="white">
                {AccommodationName}
              </Text>
              <Text size="sm" c="white" opacity={0.9}>
                {Nights} noites
              </Text>
            </div>
            <div className="mt-2">
              <img
                src={ImageURL}
                alt=""
                className="w-full object-cover rounded-lg"
                loading="lazy"
              />
            </div>
          </div>

          <Group justify="space-between" mt="md">
            <Group gap="xs">
              <i className="fa fa-star" style={{ color: "var(--mantine-color-yellow-5)" }} />
              <Text size="sm" c="yellow.7" fw={500}>
                {StarRating}
              </Text>
              <i className="fa fa-map-marker" style={{ color: "var(--mantine-color-gray-5)" }} />
              <Text size="sm" c="dimmed">
                {OfferTitle}
              </Text>
            </Group>
            <Text
              size="lg"
              fw={700}
              style={{ color: "var(--mantine-primary-color-filled)" }}
            >
              <FormatCurrency value={LeadInPrice} />
            </Text>
          </Group>

          <Group justify="space-between" mt="md">
            <Button onClick={onGeneratePdf} leftSection={<i className="fa fa-file-pdf-o" />}>
              PDF Montra
            </Button>
            <Button onClick={onPostsClick} leftSection={<i className="fa fa-instagram" />}>
              Post / Story
            </Button>
          </Group>

          <Text size="sm" c="dimmed" mt="md" className="leading-6">
            {WhatsIncluded}
          </Text>
        </div>
      </Card>
    </div>
  )
}

export default OfferEmptyState
